import { AnimatePresence } from "framer-motion";
import { useCallback, useState } from "react";

import FilePreview from "@rapid/components/file/Preview";
import { FileCarousel } from "@rapid/components/file/Carousel/FileCarousel";
import { useCoreApp } from "@rapid/contexts/CoreAppContext";
import { BoundingBoxStrategyImpl } from "@rapid/utils/annotationStrategies/BoundingBox";
import { FilePreviewProvider } from "@rapid/contexts/FilePreviewProvider";
import { useTestWithMoreFiles } from "@rapid/useTestWithMoreFiles";
import { useCurrentMedia } from "@rapid/store";

// TODO: introduce useFilePreview hook here
const TestFilesVisualAreaContent = () => {
    const { showLabels } = useCoreApp();
    const { testWithMoreFiles, uploadLimitError, clearUploadLimitError } = useTestWithMoreFiles();
    const currentMedia = useCurrentMedia();
    const [isHovered, setIsHovered] = useState(false);

    const onAddMediaItems = useCallback(
        async (files: File[], onFinally?: () => void) => {
            await testWithMoreFiles(files, onFinally);
        },
        [testWithMoreFiles]
    );

    return (
        <AnimatePresence mode="wait">
            <div
                className="visualArea"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <FilePreviewProvider>
                    <FileCarousel
                        className="h-full w-full"
                        onAddMediaItems={onAddMediaItems}
                        uploadLimitError={uploadLimitError}
                        clearUploadLimitError={clearUploadLimitError}
                        isHovered={isHovered}
                    >
                        <FilePreview
                            key={`file-${currentMedia?.file.id}`}
                            forceHideLabels={!showLabels}
                            strategy={BoundingBoxStrategyImpl}
                        />
                    </FileCarousel>
                </FilePreviewProvider>
            </div>
        </AnimatePresence>
    );
};

export const PreviewVisualAreaContent = () => {
    return <TestFilesVisualAreaContent />;
};
